import Text from "common/values/text/text";

export default class FeeScheduleBillingCode extends Text {
  constructor(value: string) {
    super(value);
  }
  public get isEmpty(): boolean {
    return this.value === '';
  }

  public isEqualTo(other: Text | null): boolean {
    if (!(other instanceof FeeScheduleBillingCode)) return false;
    return super.isEqualTo(other);
  }

  public override clone(): FeeScheduleBillingCode {
    return new FeeScheduleBillingCode(this.value);
  }

  public static get Prototype(): FeeScheduleBillingCode {
    return new FeeScheduleBillingCode('Prototype');
  }

  public override fromJSON(value: string): FeeScheduleBillingCode {
    return new FeeScheduleBillingCode(value);
  }
  public toJSON(): string {
    return this.value;
  }
}
